const MINUTES_PER_HOUR = 60
const MINUTES_PER_DAY = 1440 // x24
const MINUTES_PER_MONTH = 43200 // x30
const MINUTES_PER_YEAR = 518400 // x12

/**
 * Calculates difference between dates and return in different types
 * @param recent Recent date
 * @param past Past date
 * @returns
 */
export function DiffDates(recent: Date, past: Date) {
  const deltaMS = recent.getTime() - past.getTime()

  const totalMinutes = Math.floor(deltaMS / 60000)

  let minutes = totalMinutes
  const years = Math.floor(minutes / MINUTES_PER_YEAR)
  minutes -= years * MINUTES_PER_YEAR

  const months = Math.floor(minutes / MINUTES_PER_MONTH)
  minutes -= months * MINUTES_PER_MONTH

  const days = Math.floor(minutes / MINUTES_PER_DAY)
  minutes -= days * MINUTES_PER_DAY

  const hours = Math.floor(minutes / MINUTES_PER_HOUR)
  minutes -= hours * MINUTES_PER_HOUR

  // prettier-ignore
  const dts = {
    year:    years  > 0 ? years   + ' ano(s) '  : '',
    month:   months > 0 ? months  + ' mês(es) '  : '',
    days:    days   > 0 ? days    + ' dia(s) '  : '',
    hours:   hours  > 0 ? hours   + ' hora(s) '  : '',
    minutes:              minutes + ' min(s)'
  }

  let explained = ''
  if (days <= 1) explained = `${dts.days}${dts.hours}${dts.minutes}`
  else explained = `${dts.year}${dts.month}${dts.days}`

  return {
    raw: { years, months, days, hours, minutes },
    explained,
  }
}

//
//
//
//
//
//
//
//
//
//

type AddAmountOptions = {
  seconds?: number
  minutes?: number
  hours?: number
  days?: number
}

export function AddDate(startDate: Date, addAmount: AddAmountOptions): Date {
  const start = startDate.getTime()

  const { seconds, minutes, hours, days } = addAmount

  const milli_seconds = (seconds || 0) * 1000
  const milli_minutes = (minutes || 0) * 60000
  const milli_hours = (hours || 0) * 3600000
  const milli_days = (days || 0) * 86400000

  const final = start + milli_seconds + milli_minutes + milli_hours + milli_days

  return new Date(final)
}

//
//
//
//
//
//
//
//
//
//

type MillisecondsProps = {
  days?: number
  hours?: number
  minutes?: number
  seconds?: number
}

export function Milliseconds({
  days,
  hours,
  minutes,
  seconds,
}: MillisecondsProps) {
  let milli = 0

  if (days) milli += days * 24 * 60 * 60 * 1000
  if (hours) milli += hours * 60 * 60 * 1000
  if (minutes) milli += minutes * 60 * 1000
  if (seconds) milli += seconds * 1000

  return milli
}

//
//
//
//
//
//
//
//
//
//

export const MONTH_NAMES = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
]
